module.exports = __webpack_public_path__ + "media/assets/site_images/seeds-f4ac91b8c0d6233e2167179ca4fd84b2.jpg";